import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import PublicSiteFooter from '../components/public/PublicSiteFooter';
import PublicSiteHeader from '../components/public/PublicSiteHeader';
import { useLanguage } from '../contexts/LanguageContext';

import '../styles/public/public-site.css';

export default function PublicSiteLayout() {
  const location = useLocation();
  const { isRtl } = useLanguage();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 0);

      return () => window.clearTimeout(timer);
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    return undefined;
  }, [location.pathname, location.hash]);

  return (
    <div
      className={`public-site-shell${isRtl ? ' is-rtl' : ''}`}
      dir={isRtl ? 'rtl' : 'ltr'}
    >
      <PublicSiteHeader />
      <div className="public-site-content">
        <Outlet />
      </div>
      <PublicSiteFooter />
    </div>
  );
}
